import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import EmbedPage from './pages/EmbedPage';
import reportWebVitals from './reportWebVitals';

// "ResizeObserver loop completed with undelivered notifications" is a benign
// browser warning (the observer simply reflows on the next frame), but CRA's
// dev error overlay treats any window error as fatal and covers the app with a
// red screen. Swallow just this one message before the overlay's handler runs.
const RESIZE_OBSERVER_ERR = 'ResizeObserver loop';
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes(RESIZE_OBSERVER_ERR)) {
    e.stopImmediatePropagation();
  }
});

// The /embed/<token> route is a standalone, anonymous, chrome-less surface
// (brookebits B4a). Mount it INSTEAD of the app so no auth, nav, or app-shell
// code loads for an embedded, logged-out visitor. Everything else is the app.
const isEmbed = window.location.pathname.startsWith('/embed/');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(isEmbed ? <EmbedPage /> : <App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
